import type { TableColumn } from '@swf/poker';
import { MOBILE_COLUMNS } from '@swf/poker';

import { rowStateTimeComparator } from '../../../utils';
import TableCellState from '../../ListView/Table/TableCellState';

export const COLUMNS: TableColumn[] = [
  ...MOBILE_COLUMNS.slice(0, 2),
  {
    ...MOBILE_COLUMNS[2],
    width: undefined,
    Cell: TableCellState,
    sortType: rowStateTimeComparator
  },
  ...MOBILE_COLUMNS.slice(3)
];
